import React from 'react';
import {
  ModalContainer,
  ModalContent,
  ModalTitleDescription,
  AcceptButton,
  CancelButton,
  ModalButton
} from './styled';
import imgData from './assets/data.svg';
import Link from '@/presentation/reusables/Link';

interface IProps {
  data: {
    name: string;
    title: string;
    message: string;
    termsLink: string;
    section: string;
  };
  handleClose: any;
  goToUpdate: any;
}

const ModalUpdateView = ({
  data: { title, message, termsLink },
  handleClose,
  goToUpdate
}: IProps) => (
  <ModalContainer>
    <ModalContent>
      <ModalTitleDescription>
        <img src={imgData} alt="ImgUpdate" />
        <h1>{title}</h1>
        <div>
          <p>{message}</p>
          <p>
            Antes de continuar, revisa los{' '}
            <Link
              linkType="external"
              linkName="términos y condiciones."
              url={termsLink}
            />
          </p>
        </div>
      </ModalTitleDescription>
      <ModalButton>
        <AcceptButton onClick={goToUpdate}>
          <p>Actualiza ahora</p>
        </AcceptButton>
        <CancelButton onClick={handleClose}>
          <p>Omitir</p>
        </CancelButton>
      </ModalButton>
    </ModalContent>
  </ModalContainer>
);

export { ModalUpdateView };
